import { render, staticRenderFns } from "./EventCalendarBase.vue?vue&type=template&id=3500e4e3"
import script from "./EventCalendarBase.vue?vue&type=script&lang=js"
export * from "./EventCalendarBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports